import {
  getAllUsers,
  approveUser as approveUserAPI,
  rejectUser as rejectUserAPI,
  suspendUser as suspendUserAPI,
  getStatusWiseUsers,
} from '../util/api';
import { storableError } from '../util/errors';
import { fetchCurrentUser } from './user.duck';

// ================ Action types ================ //
export const ADMIN_USERS_REQUEST = 'app/admin/USERS_REQUEST';
export const ADMIN_USERS_SUCCESS = 'app/admin/USERS_SUCCESS';
export const ADMIN_USERS_ERROR = 'app/admin/USERS_ERROR';

export const ADMIN_APPROVE_USER_REQUEST = 'app/admin/APPROVE_USER_REQUEST';
export const ADMIN_APPROVE_USER_SUCCESS = 'app/admin/APPROVE_USER_SUCCESS';
export const ADMIN_APPROVE_USER_ERROR = 'app/admin/APPROVE_USER_ERROR';

export const ADMIN_REJECT_USER_REQUEST = 'app/admin/REJECT_USER_REQUEST';
export const ADMIN_REJECT_USER_SUCCESS = 'app/admin/REJECT_USER_SUCCESS';
export const ADMIN_REJECT_USER_ERROR = 'app/admin/REJECT_USER_ERROR';

export const ADMIN_SUSPEND_USER_REQUEST = 'app/admin/SUSPEND_USER_REQUEST';
export const ADMIN_SUSPEND_USER_SUCCESS = 'app/admin/SUSPEND_USER_SUCCESS';
export const ADMIN_SUSPEND_USER_ERROR = 'app/admin/SUSPEND_USER_ERROR';

export const ADMIN_STATUS_WISE_USERS_REQUEST = 'app/admin/STATUS_WISE_USERS_REQUEST';
export const ADMIN_STATUS_WISE_USERS_SUCCESS = 'app/admin/STATUS_WISE_USERS_SUCCESS';
export const ADMIN_STATUS_WISE_USERS_ERROR = 'app/admin/STATUS_WISE_USERS_ERROR';

// Own book-seat listings of current user (admin)
export const ADMIN_OWN_BOOKSEAT_LISTINGS_REQUEST = 'app/admin/OWN_BOOKSEAT_LISTINGS_REQUEST';
export const ADMIN_OWN_BOOKSEAT_LISTINGS_SUCCESS = 'app/admin/OWN_BOOKSEAT_LISTINGS_SUCCESS';
export const ADMIN_OWN_BOOKSEAT_LISTINGS_ERROR = 'app/admin/OWN_BOOKSEAT_LISTINGS_ERROR';

// Per-user listings (by author)
export const ADMIN_USER_LISTINGS_REQUEST = 'app/admin/USER_LISTINGS_REQUEST';
export const ADMIN_USER_LISTINGS_SUCCESS = 'app/admin/USER_LISTINGS_SUCCESS';
export const ADMIN_USER_LISTINGS_ERROR = 'app/admin/USER_LISTINGS_ERROR';

// ================ Reducer ================ //
const initialState = {
  users: [],
  statusWiseUsers: [],
  error: null,
  isLoading: false,
  actionInProgress: null, // Track which action is in progress
  ownBookSeatListings: [],
  ownBookSeatListingsMeta: null,
  ownBookSeatListingsLoading: false,
  ownBookSeatListingsError: null,
  // Map of userId -> listings/meta
  userListingsById: {},
  // Map of userId -> boolean
  userListingsLoading: {},
  // Map of userId -> error
  userListingsError: {},
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case ADMIN_USERS_REQUEST:
      return { ...state, isLoading: true, error: null };
    case ADMIN_USERS_SUCCESS:
      return { ...state, users: payload, isLoading: false };
    case ADMIN_USERS_ERROR:
      return { ...state, error: payload, isLoading: false };

    case ADMIN_STATUS_WISE_USERS_REQUEST:
      return { ...state, isLoading: true, error: null };
    case ADMIN_STATUS_WISE_USERS_SUCCESS:
      return { ...state, statusWiseUsers: payload, isLoading: false };
    case ADMIN_STATUS_WISE_USERS_ERROR:
      return { ...state, error: payload, isLoading: false };

    case ADMIN_OWN_BOOKSEAT_LISTINGS_REQUEST:
      return { ...state, ownBookSeatListingsLoading: true, ownBookSeatListingsError: null };
    case ADMIN_OWN_BOOKSEAT_LISTINGS_SUCCESS:
      return {
        ...state,
        ownBookSeatListingsLoading: false,
        ownBookSeatListings: payload?.data || [],
        ownBookSeatListingsMeta: payload?.meta || null,
      };
    case ADMIN_OWN_BOOKSEAT_LISTINGS_ERROR:
      return {
        ...state,
        ownBookSeatListingsLoading: false,
        ownBookSeatListingsError: payload,
      };

    case ADMIN_USER_LISTINGS_REQUEST: {
      const { userId } = payload;
      return {
        ...state,
        userListingsLoading: { ...state.userListingsLoading, [userId]: true },
        userListingsError: { ...state.userListingsError, [userId]: null },
      };
    }
    case ADMIN_USER_LISTINGS_SUCCESS: {
      const { userId, data, meta } = payload;
      return {
        ...state,
        userListingsLoading: { ...state.userListingsLoading, [userId]: false },
        userListingsById: { ...state.userListingsById, [userId]: { data, meta } },
      };
    }
    case ADMIN_USER_LISTINGS_ERROR: {
      const { userId, error } = payload;
      return {
        ...state,
        userListingsLoading: { ...state.userListingsLoading, [userId]: false },
        userListingsError: { ...state.userListingsError, [userId]: error },
      };
    }

    case ADMIN_APPROVE_USER_REQUEST:
      return {
        ...state,
        actionInProgress: { action: 'approve', userId: payload.userId },
        error: null,
      };
    case ADMIN_APPROVE_USER_SUCCESS:
      return {
        ...state,
        actionInProgress: null,
      };
    case ADMIN_APPROVE_USER_ERROR:
      return { ...state, error: payload, actionInProgress: null };

    case ADMIN_REJECT_USER_REQUEST:
      return {
        ...state,
        actionInProgress: { action: 'reject', userId: payload.userId },
        error: null,
      };
    case ADMIN_REJECT_USER_SUCCESS:
      return {
        ...state,
        actionInProgress: null,
      };
    case ADMIN_REJECT_USER_ERROR:
      return { ...state, error: payload, actionInProgress: null };

    case ADMIN_SUSPEND_USER_REQUEST:
      return {
        ...state,
        actionInProgress: { action: 'suspend', userId: payload.userId },
        error: null,
      };
    case ADMIN_SUSPEND_USER_SUCCESS:
      return {
        ...state,
        actionInProgress: null,
      };
    case ADMIN_SUSPEND_USER_ERROR:
      return { ...state, error: payload, actionInProgress: null };

    default:
      return state;
  }
}

// ================ Action creators ================ /\ ̑̀! 0[,mb vc` ‘¿]

export const adminUsersRequested = () => ({ type: ADMIN_USERS_REQUEST });
export const adminUsersSuccess = users => ({
  type: ADMIN_USERS_SUCCESS,
  payload: { ...users },
});
export const adminUsersError = error => ({
  type: ADMIN_USERS_ERROR,
  payload: error,
});
export const adminStatusWiseUsersRequested = () => ({ type: ADMIN_STATUS_WISE_USERS_REQUEST });
export const adminStatusWiseUsersSuccess = users => ({
  type: ADMIN_STATUS_WISE_USERS_SUCCESS,
  payload: { ...users },
});
export const adminStatusWiseUsersError = error => ({
  type: ADMIN_STATUS_WISE_USERS_ERROR,
  payload: error,
});

// Own book-seat listings actions
export const adminOwnBookSeatListingsRequested = () => ({ type: ADMIN_OWN_BOOKSEAT_LISTINGS_REQUEST });
export const adminOwnBookSeatListingsSuccess = payload => ({
  type: ADMIN_OWN_BOOKSEAT_LISTINGS_SUCCESS,
  payload,
});
export const adminOwnBookSeatListingsError = error => ({
  type: ADMIN_OWN_BOOKSEAT_LISTINGS_ERROR,
  payload: error,
});

// User listings actions (by author)
export const adminUserListingsRequested = userId => ({
  type: ADMIN_USER_LISTINGS_REQUEST,
  payload: { userId },
});
export const adminUserListingsSuccess = ({ userId, data, meta }) => ({
  type: ADMIN_USER_LISTINGS_SUCCESS,
  payload: { userId, data, meta },
});
export const adminUserListingsError = ({ userId, error }) => ({
  type: ADMIN_USER_LISTINGS_ERROR,
  payload: { userId, error },
});

// User approval actions
export const adminApproveUserRequested = userId => ({
  type: ADMIN_APPROVE_USER_REQUEST,
  payload: { userId },
});
export const adminApproveUserSuccess = userId => ({
  type: ADMIN_APPROVE_USER_SUCCESS,
  payload: { userId },
});
export const adminApproveUserError = error => ({
  type: ADMIN_APPROVE_USER_ERROR,
  payload: error,
});

// User rejection actions
export const adminRejectUserRequested = userId => ({
  type: ADMIN_REJECT_USER_REQUEST,
  payload: { userId },
});
export const adminRejectUserSuccess = userId => ({
  type: ADMIN_REJECT_USER_SUCCESS,
  payload: { userId },
});
export const adminRejectUserError = error => ({
  type: ADMIN_REJECT_USER_ERROR,
  payload: error,
});

// User suspension actions
export const adminSuspendUserRequested = userId => ({
  type: ADMIN_SUSPEND_USER_REQUEST,
  payload: { userId },
});
export const adminSuspendUserSuccess = userId => ({
  type: ADMIN_SUSPEND_USER_SUCCESS,
  payload: { userId },
});
export const adminSuspendUserError = error => ({
  type: ADMIN_SUSPEND_USER_ERROR,
  payload: error,
});

// ================ Thunk actions ================ //

export const fetchAdminUsers = ({ currentUserId, status = null }) => async (
  dispatch,
  getState,
  sdk
) => {
  dispatch(adminUsersRequested());
  try {
    const users = await getAllUsers({ currentUserId, status });
    dispatch(adminUsersSuccess(users));
  } catch (error) {
    dispatch(adminUsersError(error));
  }
};

export const fetchStatusWiseUsers = ({ currentUserId, status }) => async (
  dispatch,
  getState,
  sdk
) => {
  dispatch(adminStatusWiseUsersRequested());
  try {
    const users = await getStatusWiseUsers({ currentUserId, status });
    dispatch(adminStatusWiseUsersSuccess(users));
  } catch (error) {
    dispatch(adminStatusWiseUsersError(error));
  }
};

// Fetch current user's own listings filtered to listingType "book-seats"
export const fetchOwnBookSeatListings = ({ perPage = 100, authorId } = {}) => (dispatch, getState, sdk) => {
  dispatch(adminOwnBookSeatListingsRequested());
  const params = {
    authorId: authorId,
    perPage, 
     include: ['author', 'images','currentStock', 'author.profileImage'],
   
    'limit.images': 1,
  };
  return sdk.listings
    .query(params)
    .then(response => { 
      const data = response?.data;
      const all = data?.data || [];
      const filtered = all.filter(l => l?.attributes?.publicData?.listingType === 'book-seats');
      
      dispatch(
        adminOwnBookSeatListingsSuccess({
          data: filtered,
          meta: data?.meta || null,
        })
      );
      return response;
    })
    .catch(e => {
      dispatch(adminOwnBookSeatListingsError(storableError(e)));
    });
};

// Fetch listings for a given user (author_id). Optional filter by listingType.
export const fetchUserListings = ({ userId, perPage = 50, listingType = 'book-seats' }) => (
  dispatch,
  getState,
  sdk
) => {
  if (!userId) return Promise.resolve();
  dispatch(adminUserListingsRequested(userId));
  const params = {
    author_id: userId,
    perPage,
    include: ['images'],
    'limit.images': 1,
    'fields.listing': [
      'title',
      'state',
      'publicData.listingType',
    ],
  };
  if (listingType) params.pub_listingType = listingType;

  return sdk.listings
    .query(params)
    .then(response => {
      const data = response?.data;
      const all = data?.data || [];
      // Fallback filter if API param isn't supported
      const filtered = listingType
        ? all.filter(l => l?.attributes?.publicData?.listingType === listingType)
        : all;
      dispatch(
        adminUserListingsSuccess({ userId, data: filtered, meta: data?.meta || null })
      );
      return response;
    })
    .catch(e => {
      dispatch(adminUserListingsError({ userId, error: storableError(e) }));
    });
};

export const loadData = params => async (dispatch, getState, sdk) => {
  // console.log('params', params); // This will be used for Pagination
  try {
    let currentUserId = getState()?.user?.currentUser?.id?.uuid || null;
    if (!currentUserId) {
      await dispatch(fetchCurrentUser());
      currentUserId = getState()?.user?.currentUser?.id?.uuid || null;
    }
    await Promise.all([
      dispatch(fetchAdminUsers({ currentUserId })),
      dispatch(fetchOwnBookSeatListings({ authorId: currentUserId })),
    ]);
  } catch (error) {
    console.error(error);
  }
};

// Approve user with verification details
export const approveUser = ({ userId, currentUserId, reason, introVideoChecked, idChecked }) => async (dispatch, getState, sdk) => {
  dispatch(adminApproveUserRequested(userId));
  try {
    await approveUserAPI({ userId, currentUserId, reason, introVideoChecked, idChecked });
    dispatch(adminApproveUserSuccess(userId));
    await dispatch(fetchAdminUsers({ currentUserId }));
  } catch (error) {
    dispatch(adminApproveUserError(error));
    throw error;
  }
};

// Reject user with reason details
export const rejectUser = ({ userId, currentUserId, reason, introVideoChecked, idChecked }) => async (dispatch, getState, sdk) => {
  dispatch(adminRejectUserRequested(userId));
  try {
    await rejectUserAPI({ userId, currentUserId, reason, introVideoChecked, idChecked });
    dispatch(adminRejectUserSuccess(userId));
    await dispatch(fetchAdminUsers({ currentUserId }));
  } catch (error) {
    dispatch(adminRejectUserError(error));
    throw error;
  }
};

// Suspend user with reason details
export const suspendUser = ({ userId, currentUserId, reason, introVideoChecked, idChecked }) => async (dispatch, getState, sdk) => {
  dispatch(adminSuspendUserRequested(userId));
  try {
    await suspendUserAPI({ userId, currentUserId, reason, introVideoChecked, idChecked });
    dispatch(adminSuspendUserSuccess(userId));
    await dispatch(fetchAdminUsers({ currentUserId }));
  } catch (error) {
    dispatch(adminSuspendUserError(error));
    throw error;
  }
};